import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LibraryProvider } from './contexts/LibraryContext';
import { ApiProvider } from './contexts/ApiContext';
import App from './App';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ApiProvider>
        <LibraryProvider>
          <App />
        </LibraryProvider>
      </ApiProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if ('serviceWorker' in navigator && (import.meta as any).env?.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[SW] registration failed', err);
    });
  });
}
